import { Component, ViewChild } from '@angular/core';
import { FormBuilder, AbstractControl, UntypedFormControl } from '@angular/forms'
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { SearchService } from 'src/app/service/search.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import { DashboardService } from 'src/app/service/dashboard.service';
import { tap } from 'rxjs/operators';
import { merge, BehaviorSubject, Observable } from 'rxjs';
import { MeetingDataSource } from 'src/app/service/meeting.datasource';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MeetingService } from 'src/app/service/meeting.service';
import { MomService } from 'src/app/service/mom.service';
import { Globals } from 'src/app/service/global';
import { UserService } from 'src/app/service/user.service';
import { ConfidentialDialogComponent } from '../confidential-dialog/confidential-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ProjectStatusDialogComponent } from '../right-side-opener/project-status-dialog.component';
import {
  BreakpointObserver,
  Breakpoints,
  BreakpointState
} from '@angular/cdk/layout';
import { ViewMomDialogComponent } from '../view-mom-dialog/view-mom-dialog.component';
import { environment_const, searchTourValues } from 'src/environments/environment';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { PermissionService } from 'src/app/service/permission.service';
import { UtilityService } from 'src/app/service/utility.service';
import { CopymeetingComponent } from '../copymeeting/copymeeting.component';
import { CancelMeetingPopupComponent } from '../cancel-meeting-popup/cancel-meeting-popup.component';
import { NgxSpinnerService } from 'ngx-spinner';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'MMM DD, yyyy',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};
@Component({
  selector: 'app-grid-table',
  templateUrl: './grid-table.component.html',
  styleUrls: ['./grid-table.component.css'],
  providers: [{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },

  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    , DatePipe]

})
export class GridTableComponent {
  searchTourValues = searchTourValues;
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  dataTableJson: any;
  columns: any;
  rowData: any;
  idFilter = new UntypedFormControl('');
  dateFilter = new UntypedFormControl('');
  titleFilter = new UntypedFormControl('');
  agendaFilter = new UntypedFormControl('');
  facilitatorFilter = new UntypedFormControl('');
  participantsFilter = new UntypedFormControl('');
  typeFilter = new UntypedFormControl('');
  statusFilter = new UntypedFormControl('');
  confidentialFilter = new UntypedFormControl('');
  dataSource: any;
  displayedColumns: string[] = ['meetingDate', 'meetingTitle', 'agendaTopic', 'facilitator', 'participants', 'meetType', 'meetStatus', 'isConfidential'];
  //dataSource!: SearchMeetingDataSource;
  isLoading: boolean = false;
  meetingDataSource!: MeetingDataSource;
  filterValues = {
    meetingDate: '',
    meetingTitle: '',
    agenda: '',
    facilitator: '',
    participants: '',
    meetType: '',
    meetStatus: '',
    isConfidential: ''
  };
  id = new UntypedFormControl('');
  searchJSON: any;
  error!: string;
  totalCount!: number;
  searchValue: any = {};
  private countGlobal = new BehaviorSubject<number>(0);
  globalSearchValue: any;
  private searchFilterSub = new Subject();
  agendaArray: any = [];
  meetingInfoData: any;
  byteData: any;
  srchvalue: any;
  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
  );
  isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Medium
  )
  isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Small
  )
  matDialogRef: any;
  matDialogCancel: any;
  isFilterApplied: boolean = true;
  watchSearchFilter(): Observable<any> {
    return this.searchFilterSub.asObservable();
  }
  constructor(private spinner: NgxSpinnerService,public util:UtilityService,private permissionService:PermissionService,private sideNav:SideNavServiceService,private readonly breakpointObserver: BreakpointObserver, private dialog: MatDialog, private userService: UserService, private globals: Globals, private route: ActivatedRoute, private datePipe: DatePipe, private searchService: SearchService, private router: Router, private dashboardService: DashboardService,
    private meetingService: MeetingService, private momService: MomService) {
    this.searchJSON =
    {
      "filterCol": "meetingTitle",
      "filterText": "",
      "pageStart": 0,
      "pageEnd": 25,
      "reportedUsersId": this.globals.userId + "," + this.globals.repotingUsers,
      "searchText": "",
      "searchType": "global",
      "sort": "asc",
      "sortColumn": "meetingDate",
      "sortType": "desc",
      "type": "Search",
      "userId": localStorage.getItem("userId"),
      "visitorTimezone": this.globals.vTimeZone
    }
    //this.isLoading=true;
    this.route.queryParams.subscribe(
      params => {
   
        if (params['data'] != undefined) {
          //this.globalSearch(params['data']);
          //this.globalSearchValue = params['data'];
          //          this.isLoading = false;

        }
      }
    )
    this.findGlobalSearchTxt();
  }

  findGlobalSearchTxt(){
    if(localStorage.getItem("searchValue")!=undefined){
      var globalSearchJsonStr = localStorage.getItem("searchValue");
      var globalSearchJson:any = {};
      if(globalSearchJsonStr!=null && globalSearchJsonStr!=undefined && globalSearchJsonStr!="" && globalSearchJsonStr!="{}"){
        globalSearchJson = JSON.parse(globalSearchJsonStr);
        if(globalSearchJson!=null && globalSearchJson.globalSearchTxt!=null && globalSearchJson.globalSearchTxt!=undefined && globalSearchJson.globalSearchTxt!=""){
          this.globalSearchValue = localStorage.getItem("searchValue");
          this.searchJSON.searchText=globalSearchJson.globalSearchTxt;
          let searchElem = <HTMLInputElement>document.getElementById("globalSearchInput")
          searchElem.value=globalSearchJson.globalSearchTxt;
        }
      }
    }
  }

  copyMeeting(meeting:any){

    var accessFlag = this.permissionService.checkUserRightsWithAlert(this.util.featureList.MEETINGS,this.util.permissionType.MODIFY);
    if(!accessFlag){
      return;
    }

 
    if(meeting.isConfidential=="Y"){
      let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
        panelClass: ['animate__animated', 'animate__slideInRight'],
        disableClose: true,
        position: {
          left: "50%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "50%",
        data: { isConfidentialCheck: true, meetingObj: meeting,copyMeeting:true}
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if(size.matches){
          dialogRef.updateSize('70vw','100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        } else {
          dialogRef.updateSize('calc(100% - 50px)', '100vh');
        }
      });
      const smallSubscription = this.isSmall.subscribe(size => {
        if(size.matches){
          dialogRef.updateSize('100vw', '100vh');
        }
      })
      dialogRef.afterClosed().subscribe((data) => {
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      });
    }
    else{
      this.matDialogRef = this.dialog.open(CopymeetingComponent, {
        data:{meeting},
        panelClass: ['animate__animated','animate__slideInLeft'],
        disableClose: false,
        position : {
          left : "0%"
        },
        maxWidth: "100vw",
        maxHeight: "100vh",
        width: "50%",
        height : "100vh"
      });
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if(size.matches){
          this.matDialogRef.updateSize('70vw','100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          this.matDialogRef.updateSize('100vw', '100vh');
        } else {
          this.matDialogRef.updateSize('50%', '100vh');
        }
      });
      const smallSubscription = this.isSmall.subscribe(size => {
        if(size.matches){
          this.matDialogRef.updateSize('100vw', '100vh');
        }
      })
      this.matDialogRef.afterClosed().subscribe((data: any)=>{
        if(data == true){
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigate(['dashboard']);
          this.sideNav.openInstantMeeting(false);
          mediumDialogSubscription.unsubscribe()
          smallSubscription.unsubscribe()
          smallDialogSubscription.unsubscribe()
        }else{
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.sideNav.openInstantMeeting(false);
          mediumDialogSubscription.unsubscribe()
          smallSubscription.unsubscribe()
          smallDialogSubscription.unsubscribe()
        }
      });
    }
  }

  @ViewChild(MatSort)
  sort!: MatSort;

  ngAfterViewInit() {
    
    this.paginator.pageIndex = this.searchJSON.pageStart;
    if (this.globalSearchValue != undefined) {
      this.countGlobal
        .pipe(
          tap((count) => {
            this.paginator.length = count;
          })
        )
        .subscribe();
    }
    else {
 
      this.meetingDataSource.counter$
        .pipe(
          tap((count) => {
            this.paginator.length = count;
          })
        )
        .subscribe();

    }

  }

  cancelMeetingPopup(meetingId: any) {
    
    this.matDialogCancel = this.dialog.open(CancelMeetingPopupComponent, {

      data: {
        meetingId: meetingId.meetingId
      },
      position: {
        left: "0%"
      },
      panelClass: ['animate__animated', 'animate__slideInLeft'],
      disableClose: false,
      maxWidth: "100%",
      maxHeight: "100vh",
      width: "50%"
      // disableClose: true

    });
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if (size.matches) {
        this.matDialogCancel.updateSize('70vw', '100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if (size.matches) {
        this.matDialogCancel.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        this.matDialogCancel.updateSize('100vw', '100vh');
      }
      // else {
      //   this.matDialogRef.updateSize('50%', '100vh');
      // }
    });
    this.matDialogCancel.afterClosed().subscribe((data: any) => {
      // this.meetingDatasource.loadUpcomingMeetings(this.meetingJSON);
      // this.meetingDatasource.loadPastMeetings(this.meetingJSON);
      if(data == true){
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate(['dashboard']);
        this.sideNav.openInstantMeeting(false);
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      }else{
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.sideNav.openInstantMeeting(false);
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      }
    });
  }

  //test
  functionCheck(data : any){
 
  }

  loadSearchMeetings() {
    
    //this.meetingDataSource=new MeetingDataSource(this.dashboardService);
    this.searchJSON.pageStart = this.paginator.pageIndex;
    this.searchJSON.pageEnd = this.paginator.pageSize;
    this.meetingDataSource.loadSearchMeetings(this.searchJSON);
    //this.ngAfterViewInit();
  }

  ngOnInit() {
    //this.isLoading=true;
    this.srchvalue = localStorage.getItem("searchValue");
 
    this.watchSearchFilter().pipe(debounceTime(1500)).subscribe((data: any) => {
      
      this.applyfilter(data);
    })
    this.meetingDataSource = new MeetingDataSource(this.dashboardService);
    if (this.globalSearchValue != undefined) {
      //this.globalSearch(this.globalSearchValue);
      this.srchvalue = this.globalSearchValue;
    }
    
    if (this.srchvalue != null && this.srchvalue != "" && this.srchvalue!=undefined && this.srchvalue!="{}") {
      this.srchvalue = JSON.parse(this.srchvalue);
      
      this.searchValue.globalSearchTxt= this.srchvalue.globalSearchTxt;
      this.searchValue.meetingTitle = this.srchvalue.meetingTitle;
      this.searchValue.agendaTopic = this.srchvalue.agendaTopic;
      this.searchValue.meetingDate = this.srchvalue.meetingDate;
      this.searchValue.facilitator = this.srchvalue.facilitator;
      this.searchValue.participants = this.srchvalue.participants;
      this.searchValue.meetType = this.srchvalue.meetType;
      this.searchValue.meetStatus = this.srchvalue.meetStatus;
      this.searchValue.isConfidential = this.srchvalue.isConfidential;
      this.applyfilter(this.srchvalue);
    }
    else {
      
      
      this.meetingDataSource.loadSearchMeetings(this.searchJSON);
      //this.isLoading = false;
    }
  }
  redirectToMeeting(meeting: any, searchValue: any) {
    var meetingJson={
      "meetingStatusCode": meeting.meetingStatus,
      "isConfidential":meeting.isConfidential,
      "meetingId": meeting.meetingId,
      "meetingTitle": meeting.meetingTitle
    }
    this.meetingService.fetchMeetingWithStatusObject(meeting.meetingId).subscribe(
      (meetingRes: any) => {
       var meetingobject=meetingRes.body
    if (meeting.isConfidential == "Y") {
      if(meetingobject.meetingStatusCode == "SCH" ){
        let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
          panelClass: ['animate__animated', 'animate__slideInRight'],
          disableClose: true,
          position: {
            left: "50%"
          },
          maxWidth: "100%",
          maxHeight: "100vh",
          width: "50%",
          height: "100vh",
          data:(meetingobject.rescheduleFlag=="Y" && meetingobject.meetingStartFlag == null ? { isConfidentialCheck: true, meetingObj: meetingJson,flag:true,meetingStartFlag:""}:{ isConfidentialCheck: true, meetingObj: meetingJson,flag:true,meetingStartFlag:"Y"})
        })
    }else{
        let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
        panelClass: ['animate__animated', 'animate__slideInRight'],
        disableClose: true,
        position: {
          left: "50%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "50%",
        height: "100vh",
        data: { isConfidentialCheck: true, meetingObj:meetingJson,flag:true,showMoM : true}
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if(size.matches){
          dialogRef.updateSize('70vw','100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        } else {
          dialogRef.updateSize('calc(100% - 50px)', '100vh');
        }
      });
      const smallSubscription = this.isSmall.subscribe(size => {
        if(size.matches){
          dialogRef.updateSize('100vw', '100vh');
        }
      })
      dialogRef.afterClosed().subscribe((data) => {
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      });
    }
  }
    else {
      var req: any = { "meetingId": meeting.meetingId, "searchValue": searchValue };
          if (meetingobject.meetingStatusCode == "SCH" ){
            if(meetingobject.rescheduleFlag=="Y" && (meetingobject.meetingStartFlag == null||meetingobject.meetingStartFlag == undefined)){
               req={ "meetingId": meeting.meetingId, "searchValue": searchValue ,"flag":true,"meetingStartFlag":""}
            }else{
               req={ "meetingId": meeting.meetingId, "searchValue": searchValue ,"flag":true,"meetingStartFlag":"Y"}
            }
          }else {
            req={ "meetingId": meeting.meetingId, "searchValue": searchValue ,"flag":true,showMoM : true}
          }
          this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify(req) }, skipLocationChange: true, replaceUrl: false });
    }
  });
  }


  filterValue(data: any, event: any) {
    
    if (event.keyCode == 13) {
      this.applyfilter(data);
    } else {
      this.searchFilterSub.next(data);
    }
  }
  applyfilter(data: any) {
    
    localStorage.setItem("searchValue",JSON.stringify(data));
    var filterCol = "";
    var filterVal = "";
    for (let i = 0; i < this.displayedColumns.length; i++) {
      if ((data[this.displayedColumns[i]]) != undefined) {
        if ((data[this.displayedColumns[i]]) != "") {
          filterCol = filterCol + (this.displayedColumns[i] + "#");
          if (this.displayedColumns[i] == "meetingDate") {
            let dateFormat = this.datePipe.transform(data['meetingDate'], "MMM dd, yyyy");
            filterVal = filterVal + (dateFormat + "#");
          }
          else {
            filterVal = filterVal + (data[this.displayedColumns[i]] + "#");
          }

        }
        else {
          filterCol = filterCol + "";
          filterVal = filterVal + "";
        }

      }

    }
 
    this.searchJSON.filterCol = filterCol;
    this.searchJSON.filterText = filterVal;
    this.searchJSON.pageStart = 0;
    
    if (this.globalSearchValue != undefined) {
      this.isLoading = true;
      this.dashboardService.globalSearch(this.searchJSON).subscribe(res => {
        
        this.meetingDataSource = res.dataList;
        this.meetingDataSource.totalCount=res.totalCount;
        this.countGlobal.next(res.totalCount);
        this.isLoading = false;
      });
    }
    else {
      
      this.meetingDataSource = new MeetingDataSource(this.dashboardService);
      this.meetingDataSource.loadSearchMeetings(this.searchJSON);
      this.ngAfterViewInit();
    }
  }
  globalSearch(data: any) {
    this.isLoading = true;
    
    this.searchJSON.searchText = data;
    //this.searchJSON.filterCol="meetingTitle";
    ///this.searchJSON.filterText=data;
    
    this.dashboardService.globalSearch(this.searchJSON).subscribe(res => {
      
      this.meetingDataSource = res.dataList;
      this.meetingDataSource.totalCount=res.totalCount;
      this.countGlobal.next(res.totalCount);
      this.isLoading = false;
    });
  }
  loadGlobalSearch() {
    this.isLoading = true;
    this.searchJSON.pageStart = this.paginator.pageIndex;
    this.searchJSON.pageEnd = this.paginator.pageSize;
    this.dashboardService.globalSearch(this.searchJSON).subscribe(res => {
      
      this.meetingDataSource = res.dataList;
      this.meetingDataSource.totalCount=res.totalCount;
      this.countGlobal.next(res.totalCount);
      this.isLoading = false;
    });
  }
  globalSearchSort(jsonReq: any) {
    this.searchJSON.pageStart = this.paginator.pageIndex;
    this.searchJSON.pageEnd = this.paginator.pageSize;
    this.searchJSON.sortColumn = jsonReq.sortColumn;
    this.searchJSON.sortType = jsonReq.sortType;
    this.dashboardService.globalSearch(this.searchJSON).subscribe(res => {
      
      this.meetingDataSource = res.dataList;
      this.meetingDataSource.totalCount=res.totalCount;
      this.countGlobal.next(res.totalCount);
    });
  }
  sortData(sort: Sort) {
    //this.meetingDataSource = new MeetingDataSource(this.dashboardService);
    if (this.globalSearchValue != undefined) {
      if (sort.active == "meetingDate") {
        this.searchJSON.sortColumn = "meetingDate";
        this.searchJSON.sortType = sort.direction;
        this.globalSearchSort(this.searchJSON);
      }
      else if (sort.active == "meetingTitle") {
        this.searchJSON.sortColumn = "meetingTitle";
        this.searchJSON.sortType = sort.direction;
        this.globalSearchSort(this.searchJSON);
      }
      else if (sort.active == "agendaTopic") {
        this.searchJSON.sortColumn = "agendaTopic";
        this.searchJSON.sortType = sort.direction;
        this.globalSearchSort(this.searchJSON);
      }
      else if (sort.active == "facilitator") {
        this.searchJSON.sortColumn = "facilitator";
        this.searchJSON.sortType = sort.direction;
        this.globalSearchSort(this.searchJSON);
      }
      else if (sort.active == "participants") {
        this.searchJSON.sortColumn = "participants";
        this.searchJSON.sortType = sort.direction;
        this.globalSearchSort(this.searchJSON);
      }
      else if (sort.active == "meetType") {
        this.searchJSON.sortColumn = "meetType";
        this.searchJSON.sortType = sort.direction;
        this.globalSearchSort(this.searchJSON);
      }
      else if (sort.active == "meetStatus") {
        this.searchJSON.sortColumn = "meetStatus";
        this.searchJSON.sortType = sort.direction;
        this.globalSearchSort(this.searchJSON);
      }
      else if (sort.active == "isConfidential") {
        this.searchJSON.sortColumn = "isConfidential";
        this.searchJSON.sortType = sort.direction;
        this.globalSearchSort(this.searchJSON);
      }
    }
    else {
      
      if (sort.active == "meetingDate") {
        this.searchJSON.sortColumn = "meetingDate";
        this.searchJSON.sortType = sort.direction;
        
        this.meetingDataSource.loadSearchMeetings(this.searchJSON);
        //this.ngAfterViewInit();
      }
      else if (sort.active == "meetingTitle") {
        this.searchJSON.sortColumn = "meetingTitle";
        this.searchJSON.sortType = sort.direction;
        this.meetingDataSource.loadSearchMeetings(this.searchJSON);
      }
      else if (sort.active == "agendaTopic") {
        this.searchJSON.sortColumn = "agendaTopic";
        this.searchJSON.sortType = sort.direction;
        this.meetingDataSource.loadSearchMeetings(this.searchJSON);
      }
      else if (sort.active == "facilitator") {
        this.searchJSON.sortColumn = "facilitator";
        this.searchJSON.sortType = sort.direction;
        this.meetingDataSource.loadSearchMeetings(this.searchJSON);
      }
      else if (sort.active == "participants") {
        this.searchJSON.sortColumn = "participants";
        this.searchJSON.sortType = sort.direction;
        this.meetingDataSource.loadSearchMeetings(this.searchJSON);
      }
      else if (sort.active == "meetType") {
        this.searchJSON.sortColumn = "meetType";
        this.searchJSON.sortType = sort.direction;
        this.meetingDataSource.loadSearchMeetings(this.searchJSON);
      }
      else if (sort.active == "meetStatus") {
        this.searchJSON.sortColumn = "meetStatus";
        this.searchJSON.sortType = sort.direction;
        this.meetingDataSource.loadSearchMeetings(this.searchJSON);
      }
      else if (sort.active == "isConfidential") {
        this.searchJSON.sortColumn = "isConfidential";
        this.searchJSON.sortType = sort.direction;
        this.meetingDataSource.loadSearchMeetings(this.searchJSON);
      }

    }
  }
  onPaginateChange(event: any) {
    
    this.searchJSON.pageStart = event.pageIndex + 1;
    if (this.globalSearchValue != undefined) {
      this.loadGlobalSearch();
    } else {
      
      this.loadSearchMeetings();
    }
  }
  openPreviewMinutes(element: any) {
    
    if (element.isConfidential == "Y") {
      let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
        panelClass: ['animate__animated', 'animate__slideInRight'],
        disableClose: true,
        position: {
          left: "50%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "50%",
        data: { isConfidentialCheck: true, meetingObj: element, pdfflag: true }
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if(size.matches){
          dialogRef.updateSize('70vw','100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        } else {
          dialogRef.updateSize('calc(100% - 50px)', '100vh');
        }
      });
      const smallSubscription = this.isSmall.subscribe(size => {
        if(size.matches){
          dialogRef.updateSize('100vw', '100vh');
        }
      })
      dialogRef.afterClosed().subscribe((data) => {
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      });
    }
    else {
      this.previewMinutes(element.meetingId, element.pkMomDetailId);
    }

  }
  previewMinutes(meetingId: number, pkMomDetailId: number) {
 
    this.agendaArray = [];
    this.meetingService.fetchMeetingInfo(meetingId).subscribe(
      (meetingRes: any) => {
        this.meetingInfoData = meetingRes.body;
        var minuteJSON = {
          // "deletedFlag": 0,
          "meetingId": this.meetingInfoData.meetingId,
          "pkMomDetailId": pkMomDetailId,
          //"reviewType": "RA",
          //"orgCode": this.meetingInfoData.orgCode,
          "momStatus": environment_const.momApproveStatus,
          "userId": Number(localStorage.getItem("userId")),
          "reportedUsersId": this.globals.userId + "," + this.globals.repotingUsers,
          "fkMeetingEntityId": this.meetingInfoData.meetingId
        };
        this.isLoading = true;
        this.momService.viewMoM(minuteJSON).subscribe((response) => {
          let file = new Blob([response], { type: 'application/pdf' });
          this.byteData = file;
          var blobUrl = URL.createObjectURL(file);
          window.open(blobUrl);
          this.isLoading = false;
        })
      });
  }
  loadMeetingInfo(meeting: any) {
    if (meeting.isConfidential == "Y") {
      let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
        panelClass: ['animate__animated', 'animate__slideInRight'],
        disableClose: true,
        position: {
          left: "50%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "50%",
        data: { isConfidentialCheck: true, meetingObj: meeting, flag: true, viewMeetingInfo: true }
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if(size.matches){
          dialogRef.updateSize('70vw','100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        } else {
          dialogRef.updateSize('calc(100% - 50px)', '100vh');
        }
      });
      const smallSubscription = this.isSmall.subscribe(size => {
        if(size.matches){
          dialogRef.updateSize('100vw', '100vh');
        }
      })
      dialogRef.afterClosed().subscribe((data) => {
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      });
    }
    else {
      this.spinner.show();
      this.meetingService.fetchMeetingInfo(meeting.meetingId).subscribe(

        (meetingRes: any) => {
          this.spinner.hide()
          this.meetingInfoData = meetingRes.body
          const d = this.dialog.open(ProjectStatusDialogComponent, {
            data: { meetingData: this.meetingInfoData, hide: false, hideUseTemplate: true },
            panelClass: ['animate__animated', 'animate__slideInRight', 'responsive-class'],
            disableClose: false,
            position: {
              left: "50%"
            },
            maxWidth: "100%",
            maxHeight: "100vh",
            width: "50%",
            height: "100vh"
          })
          const mediumDialogSubscription = this.isMedium.subscribe(size => {
            if (size.matches) {
              d.updateSize('70vw', '100vh');
            }
          })
          const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
            if (size.matches) {
              d.updateSize('100vw', '100vh');
            } else {
              d.updateSize('calc(100% - 50px)', '100vh');
            }
          });
          const smallSubscription = this.isSmall.subscribe(size => {
            if (size.matches) {
              d.updateSize('100vw', '100vh');
            }
          })
          d.afterClosed().subscribe(() => {
            smallDialogSubscription.unsubscribe();
            smallSubscription.unsubscribe();
            mediumDialogSubscription.unsubscribe();
          });
        },
        err => {
        }).add(() => {
        });
    }
  }
  resetData() {
    
    this.searchValue.meetingTitle = "";
    this.searchValue.meetingDate = "";
    this.searchValue.agendaTopic = "";
    this.searchValue.facilitator = "";
    this.searchValue.participants = "";
    this.searchValue.meetType = "";
    this.searchValue.meetStatus = "";
    this.searchValue.isConfidential = "";
    localStorage.removeItem("searchValue");
    this.searchJSON.filterCol = "meetingTitle";
    this.searchJSON.filterText = "";
    this.searchJSON.pageStart = 0;
    this.searchJSON.pageEnd = 10;
    this.globalSearchValue=undefined;
    this.meetingDataSource = new MeetingDataSource(this.dashboardService);
    this.meetingDataSource.loadSearchMeetings(this.searchJSON);
    this.meetingDataSource.counter$.pipe(
      tap((count) => {
        this.paginator.length = count;
      })
    ).subscribe();
  }
  clearSearchField(data: any, text: any) {
    if (data == "meetingTitle") {
      this.searchValue.meetingTitle = "";
      this.applyfilter(text);
    }
    if (data == "agendaTopic") {
      this.searchValue.agendaTopic = "";
      this.applyfilter(text);
    }
    if (data == "meetingDate") {
      this.searchValue.meetingDate = "";
      this.applyfilter(text);
    }
    if (data == "facilitator") {
      this.searchValue.facilitator = "";
      this.applyfilter(text);
    }
    if (data == "participants") {
      this.searchValue.participants = "";
      this.applyfilter(text);
    }
    if (data == "meetType") {
      this.searchValue.meetType = "";
      this.applyfilter(text);
    }
    if (data == "meetStatus") {
      this.searchValue.meetStatus = "";
      this.applyfilter(text);
    }
    if (data == "isConfidential") {
      this.searchValue.isConfidential = "";
      this.applyfilter(text);
    }

  }

}
